<template>
  <path
    d="M16 6.00024V4.00024C16 2.90024 15.1 2.00024 14 2.00024H10C8.9 2.00024 8 2.90024 8 4.00024V6.00024H4C2.9 6.00024 2 6.90024 2 8.00024V19.0002C2 20.1002 2.9 21.0002 4 21.0002H20C21.1 21.0002 22 20.1002 22 19.0002V8.00024C22 6.90024 21.1 6.00024 20 6.00024H16ZM10 4.00024H14V6.00024H10V4.00024ZM9 17.0702V9.83024C9 9.45024 9.4 9.21024 9.74 9.39024L15.77 12.6002C16.1 12.7802 16.13 13.2502 15.81 13.4602L9.78 17.4802C9.45 17.7002 9 17.4702 9 17.0702Z"
  />
</template>
